(() => {
  if (window.__P80_KLAVIYO_MOVED_V4__) return;
  window.__P80_KLAVIYO_MOVED_V4__ = true;

  const MOBILE_QUERY = '(max-width: 749px)';
  const FRAME_STYLE_PROPS = [
    'position',
    'top',
    'right',
    'left',
    'bottom',
    'inset',
    'transform',
    'z-index',
    'margin',
    'min-width',
    'max-width',
    'flex-shrink',
    'flex-grow',
  ];

  let bodyObserver;
  let formObserver;
  let timer;

  function setImportant(el, property, value) {
    el.style.setProperty(property, value, 'important');
  }

  function isKlaviyoFrame(el) {
    return (
      el.hasAttribute('data-kl-scroll-locking-modal') ||
      el.getAttribute('role') === 'dialog' ||
      !!el.querySelector('form.klaviyo-form')
    );
  }

  function restoreKlaviyoFrame(form) {
    document.querySelectorAll('#p80-klaviyo-close').forEach((el) => {
      const restore = isKlaviyoFrame(el);
      el.removeAttribute('id');
      if (!restore) return;
      FRAME_STYLE_PROPS.forEach((prop) => el.style.removeProperty(prop));
    });

    if (!form) return;
    let node = form.parentElement;
    for (let i = 0; i < 8 && node && node !== document.body; i++) {
      if (node.style.getPropertyPriority('min-width') === 'important') {
        ['width', 'max-width', 'min-width', 'flex-shrink', 'flex-grow', 'margin-left', 'margin-right'].forEach(
          (prop) => node.style.removeProperty(prop)
        );
      }
      node = node.parentElement;
    }
  }

  function isOverlay(el) {
    if (!el || el === document.body) return true;
    if (el.getAttribute('role') === 'dialog') return true;
    if (el.hasAttribute('data-kl-scroll-locking-modal')) return true;
    const cs = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();
    return (
      cs.position === 'fixed' &&
      rect.width >= window.innerWidth - 24 &&
      rect.height >= window.innerHeight * 0.75
    );
  }

  function getScale(el) {
    const inline = el.style.transform || '';
    if (/scale\s*\(/i.test(inline)) {
      const match = inline.match(/scale\s*\(\s*([0-9.]+)/i);
      return match ? parseFloat(match[1]) : 0.5;
    }
    const computed = window.getComputedStyle(el).transform;
    if (!computed || computed === 'none') return 1;
    const matrix = computed.match(/matrix\(([^)]+)\)/);
    if (!matrix) return 1;
    return Math.abs(parseFloat(matrix[1].split(',')[0]) || 1);
  }

  function neutralizeKlaviyoScale(form, isMobile) {
    let node = form.parentElement;
    for (let i = 0; i < 12 && node && node !== document.body; i++) {
      if (isOverlay(node)) break;
      const marked = node.hasAttribute('data-p80-klaviyo-card');
      if (marked || getScale(node) < 0.99) {
        node.setAttribute('data-p80-klaviyo-card', '');
        setImportant(node, 'transform', 'none');
        setImportant(node, 'margin-left', '0');
        setImportant(node, 'margin-right', '0');
        setImportant(node, 'max-height', 'none');
        setImportant(node, 'width', isMobile ? 'calc(100% - 3.2rem)' : '100%');
        setImportant(node, 'max-width', '60rem');
        break;
      }
      node = node.parentElement;
    }
  }

  function styleCloseIcon(form) {
    const root = form.closest('[role="dialog"]') || form.parentElement || document;
    root
      .querySelectorAll(
        'button[aria-label="Close dialog"] svg path, button[aria-label="Close form"] svg path, .klaviyo-close-form svg path'
      )
      .forEach((path) => {
        path.setAttribute('stroke', '#ffffff');
        path.setAttribute('fill', '#ffffff');
        setImportant(path, 'stroke', '#ffffff');
        setImportant(path, 'fill', '#ffffff');
        setImportant(path, 'color', '#ffffff');
      });
  }

  function styleFormShell(form) {
    setImportant(form, 'min-height', '0');
    setImportant(form, 'height', 'auto');

    Array.from(form.children).forEach((child) => {
      if (child.tagName !== 'DIV') return;
      setImportant(child, 'min-height', '0');
      setImportant(child, 'height', 'auto');
      Array.from(child.children).forEach((inner) => {
        if (inner.tagName !== 'DIV') return;
        if (inner.getAttribute('data-testid') === 'form-row') return;
        setImportant(inner, 'min-height', '0');
        setImportant(inner, 'height', 'auto');
      });
    });
  }

  function styleRows(form, isMobile) {
    const sidePad = isMobile ? '1.6rem' : '4.8rem';
    const headlineSize = isMobile ? '3.2rem' : '4.8rem';

    form.querySelectorAll('[data-testid="form-row"]').forEach((row) => {
      setImportant(row, 'display', 'block');
      setImportant(row, 'width', '100%');
      setImportant(row, 'box-sizing', 'border-box');
      setImportant(row, 'min-height', '0');
      setImportant(row, 'height', 'auto');
      setImportant(row, 'flex-grow', '0');

      const isLogo = !!row.querySelector('.klaviyo-form-image');
      const prev = row.previousElementSibling;
      const next = row.nextElementSibling;
      const isHeadline = !!(
        row.querySelector('.klaviyo-form-headline') ||
        (prev && prev.querySelector && prev.querySelector('.klaviyo-form-image'))
      );
      const isAddress = !!(
        row.querySelector('.klaviyo-form-richtext-address, .p80-klaviyo-address') ||
        /WASHINGTON|INDIANAPOLIS/i.test(row.textContent || '')
      );
      const isIntro = !!(
        !isAddress &&
        row.querySelector('.klaviyo-form-richtext, .klaviyo-form-rich-text')
      );

      if (isLogo) {
        const logo = row.querySelector('.klaviyo-form-image');
        if (logo) setImportant(logo, 'padding', '2.4rem 1.6rem 0.8rem');
      } else if (isHeadline) {
        setImportant(row, 'padding', '2.4rem 0');
        setImportant(row, 'margin', '0');
        setImportant(row, 'border', '0');
        setImportant(row, 'width', '100%');
        setImportant(row, 'max-width', 'none');
        setImportant(row, 'overflow', 'hidden');
        row.querySelectorAll('img').forEach((img) => setImportant(img, 'display', 'none'));
        row.querySelectorAll('div').forEach((el) => {
          setImportant(el, 'border', '0');
          setImportant(el, 'margin', '0');
          setImportant(el, 'background-image', 'none');
        });
        row.querySelectorAll('h1, h2, p, span').forEach((el) => {
          setImportant(el, 'font-size', headlineSize);
          setImportant(el, 'font-weight', '500');
          setImportant(el, 'line-height', headlineSize);
          setImportant(el, 'font-style', 'normal');
        });
      } else {
        const hasContent = row.querySelector(
          '.klaviyo-form-richtext-address, .klaviyo-form-rich-text, .button.button--primary, .button.button--secondary, .klaviyo-form-richtext'
        );
        if (!hasContent) {
          setImportant(row, 'display', 'none');
          setImportant(row, 'padding', '0');
          setImportant(row, 'height', '0');
          setImportant(row, 'min-height', '0');
        } else if (isAddress) {
          setImportant(row, 'padding', `0 ${sidePad}`);
        } else if (row.querySelector('.button.button--primary')) {
          setImportant(row, 'padding', `2.4rem ${sidePad}`);
        } else if (row.querySelector('.button.button--secondary')) {
          setImportant(row, 'padding', `0 ${sidePad} 2.4rem`);
          setImportant(row, 'min-height', '0');
        } else if (isIntro) {
          setImportant(row, 'padding', `2.4rem ${sidePad} 1.6rem`);
        }
      }

      row.querySelectorAll('div').forEach((el) => {
        if (el === row || el.getAttribute('data-testid') === 'form-row') return;
        if (el.closest && el.closest('button')) return;
        if (el.classList && el.classList.contains('klaviyo-form-image')) return;
        if (el.closest && el.closest('.klaviyo-form-image')) return;
        if (el.classList && el.classList.contains('p80-klaviyo-address')) return;
        if (el.closest && el.closest('.p80-klaviyo-address')) return;
        setImportant(el, 'padding-top', '0');
        setImportant(el, 'padding-right', '0');
        setImportant(el, 'padding-bottom', '0');
        setImportant(el, 'padding-left', '0');
      });

      row.querySelectorAll(':scope > div').forEach((child) => {
        if (isHeadline) return;
        if (child.querySelector && (child.querySelector('.klaviyo-form-richtext-address') || isAddress)) return;
        setImportant(child, 'display', 'block');
        setImportant(child, 'width', '100%');
        setImportant(child, 'max-width', 'none');
        setImportant(child, 'box-sizing', 'border-box');
      });
    });
  }

  function findAddressTarget(form) {
    const existing = form.querySelector('.p80-klaviyo-address');
    if (existing) return existing;

    const nodes = form.querySelectorAll(
      '[data-testid="form-component"], .klaviyo-form-richtext-address, .klaviyo-form-rich-text, .klaviyo-form-richtext'
    );
    let best = null;
    for (const node of nodes) {
      const text = (node.textContent || '').toUpperCase();
      if (!text.includes('WASHINGTON') && !text.includes('INDIANAPOLIS')) continue;
      if (!best || best.contains(node)) best = node;
    }
    return best;
  }

  function styleAddress(form, isMobile) {
    const target = findAddressTarget(form);
    if (!target) return;

    target.classList.add('p80-klaviyo-address');
    setImportant(target, 'display', 'flex');
    setImportant(target, 'flex-direction', 'row');
    setImportant(target, 'flex-wrap', 'nowrap');
    setImportant(target, 'align-items', 'center');
    setImportant(target, 'justify-content', 'center');
    setImportant(target, 'padding', isMobile ? '1.2rem 1.6rem' : '2.4rem');
    setImportant(target, 'min-height', isMobile ? '4.8rem' : '8.8rem');
    setImportant(target, 'height', 'auto');
    setImportant(target, 'width', '100%');
    setImportant(target, 'max-width', isMobile ? '100%' : '50.4rem');
    setImportant(target, 'margin', '0 auto');
    setImportant(target, 'gap', '0.8rem');
    setImportant(target, 'column-gap', '0.8rem');
    setImportant(target, 'row-gap', '0');
    setImportant(target, 'background', '#e1edf5');
    setImportant(target, 'background-color', '#e1edf5');
    setImportant(target, 'box-sizing', 'border-box');

    const addressSize = isMobile ? '1.2rem' : '2rem';
    target
      .querySelectorAll('p, span, .klaviyo-form-richtext-address, .klaviyo-form-rich-text, .klaviyo-form-richtext')
      .forEach((el) => {
        setImportant(el, 'font-size', addressSize);
        setImportant(el, 'line-height', isMobile ? '1.6rem' : addressSize);
        setImportant(el, 'font-family', 'Nord, Arial, sans-serif');
        setImportant(el, 'font-weight', '900');
        setImportant(el, 'font-style', 'italic');
        setImportant(el, 'color', '#253d81');
        setImportant(el, 'text-align', 'left');
        setImportant(el, 'text-transform', 'uppercase');
        setImportant(el, 'white-space', 'normal');
        setImportant(el, 'background', 'transparent');
      });

    target.querySelectorAll(':scope > div').forEach((inner) => {
      setImportant(inner, 'width', 'auto');
      setImportant(inner, 'flex', '0 1 auto');
      setImportant(inner, 'margin', '0');
      setImportant(inner, 'padding', '0');
      setImportant(inner, 'background', 'transparent');
    });
  }

  function styleButtons(form) {
    form.querySelectorAll('button.button--primary, button.button--secondary').forEach((btn) => {
      const parent = btn.parentElement;
      if (parent) {
        setImportant(parent, 'display', 'block');
        setImportant(parent, 'width', '100%');
        setImportant(parent, 'max-width', 'none');
        setImportant(parent, 'min-height', '0');
        setImportant(parent, 'height', 'auto');
        setImportant(parent, 'padding', '0');
      }

      setImportant(btn, 'display', 'block');
      setImportant(btn, 'width', '100%');
      setImportant(btn, 'max-width', 'none');
      setImportant(btn, 'min-width', '0');
      setImportant(btn, 'white-space', 'nowrap');
      setImportant(btn, 'box-sizing', 'border-box');
      setImportant(btn, 'overflow', 'visible');
      setImportant(btn, 'flex-grow', '0');

      if (btn.classList.contains('button--primary')) {
        setImportant(btn, 'background', '#253d81');
        setImportant(btn, 'background-color', '#253d81');
        setImportant(btn, 'background-image', 'none');
        setImportant(btn, 'color', '#ffffff');
        setImportant(btn, '-webkit-text-fill-color', '#ffffff');
        setImportant(btn, 'padding', '1.2rem 3.2rem');
        setImportant(btn, 'border', '0');
        setImportant(btn, 'opacity', '1');
        setImportant(btn, 'box-shadow', '0 0 0 0.4rem #ffffff, 0 0 0 0.5rem #253d81');
        btn.querySelectorAll('*').forEach((child) => {
          setImportant(child, 'color', '#ffffff');
          setImportant(child, '-webkit-text-fill-color', '#ffffff');
          setImportant(child, 'background', 'transparent');
          setImportant(child, 'opacity', '1');
        });
      } else {
        setImportant(btn, 'min-height', '0');
        setImportant(btn, 'height', 'auto');
        setImportant(btn, 'padding', '0');
        setImportant(btn, 'text-decoration', 'underline');
        setImportant(btn, 'text-underline-offset', '0.4rem');
        setImportant(btn, 'text-decoration-thickness', '0.2rem');
      }
    });

    const continueBtn = form.querySelector('button.button--secondary');
    if (!continueBtn) return;
    const continueRow = continueBtn.closest('[data-testid="form-row"]');
    if (!continueRow) return;

    setImportant(continueRow, 'padding-bottom', '2.4rem');
    setImportant(continueRow, 'min-height', '0');
    let sibling = continueRow.nextElementSibling;
    while (sibling) {
      setImportant(sibling, 'display', 'none');
      setImportant(sibling, 'height', '0');
      setImportant(sibling, 'min-height', '0');
      setImportant(sibling, 'padding', '0');
      setImportant(sibling, 'margin', '0');
      sibling = sibling.nextElementSibling;
    }
  }

  function getObserveRoot(form) {
    return form.closest('[role="dialog"]') || form;
  }

  function observeForm(form) {
    if (!formObserver || !form) return;
    formObserver.disconnect();
    formObserver.observe(getObserveRoot(form), {
      attributes: true,
      subtree: true,
      attributeFilter: ['style', 'class'],
    });
  }

  function styleMovedForm() {
    const form = document.querySelector('form.klaviyo-form');
    restoreKlaviyoFrame(form);
    if (!form) return;

    if (formObserver) formObserver.disconnect();
    try {
      const isMobile = window.matchMedia(MOBILE_QUERY).matches;
      neutralizeKlaviyoScale(form, isMobile);
      styleCloseIcon(form);
      styleFormShell(form);
      styleRows(form, isMobile);
      styleAddress(form, isMobile);
      styleButtons(form);
    } finally {
      observeForm(form);
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(styleMovedForm, 50);
  }

  function init() {
    formObserver = new MutationObserver(schedule);
    bodyObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('form.klaviyo-form') || node.querySelector?.('form.klaviyo-form')) {
            schedule();
            return;
          }
        }
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    window.matchMedia(MOBILE_QUERY).addEventListener('change', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
